<div class="input-group mb-3">
  <input type="text" class="form-control" placeholder="Buscar..." />
  <div class="input-group-append">
    <button class="btn btn-outline-secondary" type="button">Buscar</button>
  </div>
</div>
